// window.onload = topoImagesIterator();
//
// var topo_images,
//      topoImageParentBackgroundImage;
//
// function topoImagesIterator() {
//     topo_images = document.getElementsByClassName('topo-image');
//
//     topo_images.forEach(setSingleTopoImageSizes(image));
// }
//
// function getNewWidth() {
//     return topoImageParentBackgroundImage.width;
// }
//
// function getNewHeight() {
//     return topoImageParentBackgroundImage.height;
// }
//
// function getOriginalWidth() {
//     return topoImageParentBackgroundImage.naturalWidth;
// }
//
// function getOriginalHeight() {
//     return topoImageParentBackgroundImage.naturalHeight;
// }
//
// function getRatio() {
//     return getNewHeight()/getOriginalHeight();
// }
//
// function getLostWidthOnResize() {
//     var dividend = getOriginalWidth() * getRatio() - getNewWidth(),
//          divider = 2;
//
//     return dividend/divider;
// }
//
// function calculateHeightWithRatio() {
//     return getOriginalHeight() * getRatio();
// }
//
// function calculateWidthWithRatio() {
//     return getOriginalWidth() * getRatio() - getLostWidthOnResize();
// }
//
// function getParentBackgroundImage(currentImage){
//     return currentImage.parentElement.parentElement;
// }
//
// function setTopoImageWidth(currentImage) {
//     currentImage.style.width = calculateWidthWithRatio();
// }
//
// function setTopoImageHeight(currentImage) {
//     currentImage.style.height = calculateHeightWithRatio();
// }
//
// function setSingleTopoImageSizes(currentImage) {
//     getParentBackgroundImage(currentImage);
//
//     setTopoImageWidth(currentImage);
//     setTopoImageHeight(currentImage);
// }
